export enum OrderManualTaskTasksPriceRuleTypes {
  MediaDuration = "MediaDuration",
  MediaVideoProfile = "MediaVideoProfile",
}
